export default defineNuxtPlugin((nuxtApp) => {
    return {
        provide: {
            handleSwiper: ( error ) => {
                
                if( error?.message === "Cannot read properties of undefined (reading 'removeEventListener')" ){
                    
                    console.warn("[Handled Swiper Error]:", error.message);
                    return true
                }
                throw error
            }
        }
    }
})